var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.elements.length > 0)?_c('div',{staticClass:"elements-container row"},_vm._l((_vm.elements),function(element){return _c('div',{key:element.id,class:`${
        _vm.displayImage(element) ? 'col-6' : 'col-12'
      } element-container`,style:(_vm.getDynamicPageBg(element))},[_c('div',{staticClass:"container"},[_c('custom-view-section',{attrs:{"element":element,"quick-link-list":_vm.quickLinkList}})],1)])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }